import { DashboardPagination } from '@/constants/pagination';
import { PaginationDashboardAPI } from '@/types/pagination';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type DashboardState = {
  dataDasboard: DashboardType;
  pagination: PaginationDashboardAPI;
  loading: boolean;
  totalElements?: number;
};

export const dashboardInitialState: DashboardState = {
  dataDasboard: {},
  pagination: {
    TransactionPage: DashboardPagination.TransactionPage,
    TransactionSize: DashboardPagination.TransactionSize,
    CardPage: DashboardPagination.CardPage,
    CardSize: DashboardPagination.CardSize,
    totalPages: 0,
    totalElements: 0,
  },
  loading: false,
};

const slice = createSlice({
  name: 'dashboard',
  initialState: dashboardInitialState,
  reducers: {
    setListDashboardAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: DashboardType;
        pagination?: PaginationDashboardAPI;
        totalExtend?: number;
        append?: boolean;
        onlyUpdateTransactions?: boolean;
        onlyUpdateCards?: boolean;
      }>,
    ) {
      if (payload.append && state.dataDasboard.transactions && payload.data.transactions) {
        // Append new transactions to existing ones
        state.dataDasboard.transactions.content = [
          ...state.dataDasboard.transactions.content,
          ...payload.data.transactions.content,
        ];
        // Update pagination info
        if (payload.data.transactions) {
          state.dataDasboard.transactions.totalPages = payload.data.transactions.totalPages;
          state.dataDasboard.transactions.totalElements = payload.data.transactions.totalElements;
          state.dataDasboard.transactions.last = payload.data.transactions.last;
          state.dataDasboard.transactions.number = payload.data.transactions.number;
        }
        // Giữ nguyên cards khi append transactions
        // Không update cards data
      } else if (payload.onlyUpdateTransactions && payload.data.transactions) {
        // Chỉ update transactions, giữ nguyên cards
        if (state.dataDasboard.transactions) {
          state.dataDasboard.transactions = payload.data.transactions;
        } else {
          state.dataDasboard.transactions = payload.data.transactions;
        }
        // Giữ nguyên cards và totalBalance
      } else if (payload.onlyUpdateCards && payload.data.cards) {
        // Chỉ update cards, giữ nguyên transactions
        if (state.dataDasboard.cards) {
          state.dataDasboard.cards = payload.data.cards;
        } else {
          state.dataDasboard.cards = payload.data.cards;
        }
        // Giữ nguyên transactions và totalBalance
      } else {
        // Update toàn bộ data
        state.dataDasboard = payload.data;
      }
      state.pagination = payload.pagination || state.pagination;
      if (payload.data.transactions) {
        state.totalElements = payload.data.transactions.totalElements;
      }
    },
    updateDashboardCardAction(
      state,
      {
        payload,
      }: PayloadAction<{
        id: string;
        changes: Partial<ContentCard>;
      }>,
    ) {
      if (state.dataDasboard.cards?.content) {
        state.dataDasboard.cards.content = state.dataDasboard.cards.content.map((item) => {
          if (item.id === payload.id) {
            // merge partial changes with existing card
            return {
              ...item,
              ...payload.changes,
            };
          }
          return item;
        });
      }
    },
  },
});

export const { setListDashboardAction, updateDashboardCardAction } = slice.actions;
export default slice.reducer;
